import styled from "styled-components";

import { alignItemsCenter } from "@styles/Utilities.styled";


export const StyledOverviewCard = styled.div`
  .diff {
    ${alignItemsCenter}
  }
`;
